var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1553 1.82373V1.24854H24.8599V1.82373H24.4814C24.2897 1.82373 24.1938 1.9196 24.1938 2.11133V2.24756C24.1938 2.48975 24.1182 2.68652 23.9668 2.83789C23.8255 2.98926 23.6338 3.06494 23.3916 3.06494H18.6538C18.4116 3.06494 18.2148 2.98926 18.0635 2.83789C17.9121 2.68652 17.8364 2.48975 17.8364 2.24756V2.11133C17.8364 1.9196 17.7406 1.82373 17.5488 1.82373H17.1553ZM0.625977 22.3794C0.625977 22.0565 0.726888 21.7891 0.928711 21.5771C1.14062 21.3652 1.40804 21.2593 1.73096 21.2593H5.03076V3.64014C5.03076 2.6613 5.27799 1.92969 5.77246 1.44531C6.27702 0.950846 7.00863 0.703613 7.96729 0.703613H34.0327C34.9914 0.703613 35.7179 0.950846 36.2124 1.44531C36.7069 1.92969 36.9541 2.6613 36.9541 3.64014V21.2593H40.269C40.592 21.2593 40.8543 21.3652 41.0562 21.5771C41.2681 21.7891 41.374 22.0565 41.374 22.3794C41.374 22.6922 41.2681 22.9546 41.0562 23.1665C40.8543 23.3885 40.592 23.4995 40.269 23.4995H1.73096C1.40804 23.4995 1.14062 23.3885 0.928711 23.1665C0.726888 22.9546 0.625977 22.6922 0.625977 22.3794ZM6.15088 21.2593H35.8491V3.80664C35.8491 3.14062 35.6826 2.64616 35.3496 2.32324C35.0166 1.99023 34.5171 1.82373 33.8511 1.82373H8.14893C7.493 1.82373 6.99349 1.99023 6.65039 2.32324C6.31738 2.64616 6.15088 3.14062 6.15088 3.80664V21.2593Z",
    fill: "url(#paint0_linear_466_1281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_466_1281",
    x1: 21,
    y1: -12,
    x2: 21,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5fcd6843fdcc06fb7bdd1f328c825f6a.svg";
export { ForwardRef as ReactComponent };